// extracted by mini-css-extract-plugin
module.exports = {"headerWrap":"header_headerWrap__1UmZV","avatar":"header_avatar__1yr3k","buttonsWrap":"header_buttonsWrap__3KamY","logo":"header_logo__1X7aW","small":"header_small__1zcWI"};